import { useQuery } from '@tanstack/react-query';
import { mockAdvisor, mockMessages, Advisor, Message } from '@mocks/advisor';
import { queryKeys } from '../queryKeys';

// Mock API calls
const fetchAdvisor = async (): Promise<Advisor> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockAdvisor), 300);
  });

const fetchMessages = async (): Promise<Message[]> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockMessages), 400);
  });

export const useAdvisor = () =>
  useQuery({
    queryKey: queryKeys.advisor,
    queryFn: fetchAdvisor,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

export const useMessages = () =>
  useQuery({
    queryKey: queryKeys.messages,
    queryFn: fetchMessages,
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 30 * 1000, // Refetch every 30 seconds for new messages
  });
